/**
 * Get the full image URL, using CDN URL if available, otherwise fallback to local path
 * @param {string} imagePath - The image path (e.g., "/images/logo.png")
 * @returns {string} - The full image URL
 */
export const getImageUrl = (imagePath) => {
  const imgUrl = import.meta.env.VITE_IMG_URL;
  
  // If IMG_URL is set and not empty, use it as CDN base URL
  if (imgUrl && imgUrl.trim() !== '') {
    // Remove leading slash from imagePath if it exists to avoid double slashes
    const cleanPath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;
    // Ensure IMG_URL doesn't end with slash to avoid double slashes
    const baseUrl = imgUrl.endsWith('/') ? imgUrl.slice(0, -1) : imgUrl;
    return `${baseUrl}/${cleanPath}`;
  }
  
  // Fallback to local path
  return imagePath;
};
